


























































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import { getDefaultAloFlux } from '@/models/alo/AloFlux';

@Component({
  name: 'GestionFlux',  
})
export default class GestionFlux extends Vue {
  private loading = false
  private showError = false  
  private showNew = false
  private newFlux = getDefaultAloFlux()
  
  private toolbarHeight = 50

  private get tableauHeight() {    
    return this.$store.myGetters.contentHeight - this.toolbarHeight - 25
  }

  onResize(){
    //@ts-ignore
    this.toolbarHeight = this.$refs.toolbar.$el.clientHeight
  }

  private get flux() {
    return this.$store.myGetters.fluxList
  }

  private get search(){
    return this.$store.myGetters.searchFlux
  }
  private set search(value){
    this.$store.myActions.UI_SET_SEARCH_FLUX(value)
  }

  private get sortDesc(){
    return this.$store.myGetters.sortFluxDesc
  }
  private set sortDesc(value){
    this.$store.myActions.UI_SET_SORT_FLUX_DESC(value)
  }

  private get sortBy(){
    return this.$store.myGetters.sortFluxBy
  }
  private set sortBy(value){
    this.$store.myActions.UI_SET_SORT_FLUX_BY(value)
  }

  private headers = [
    { text: 'ID', value: 'id' , width:"80"},
    { text: 'Nom du flux', value: 'libelle' },
    { text: 'Type', value: 'flxCatalogTyp' }
  ]

  created() {
    this.loading = true
    this.$store.myActions.ADM_FLUX_REQUEST().finally(() => {
      this.loading = false
    })
  }

  openDetail(item: any) {
    this.$router.push({name:'ModifyFlux',params:{fluxId:item.id}})
  }

  addFlux() {
    this.showNew = true  
    this.newFlux = {...getDefaultAloFlux(),ensId:this.$store.myGetters.userProfile.ensId}
  }

  save(){
    this.$store.myActions.ADM_FLUX_SAVE_REQUEST(this.newFlux).then((flux)=>{
      this.showNew = false
      this.openDetail(flux)
    })    
  }
  
}
